import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const LineColoured = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="M22 11.213C22 6.684 17.514 3 12 3S2 6.684 2 11.213c0 4.06 3.558 7.46 8.363 8.103.326.07.77.217.881.498.101.256.066.657.032.916l-.142.866c-.044.256-.201 1 .866.545 1.067-.455 5.759-3.431 7.857-5.875 1.45-1.609 2.143-3.24 2.143-5.053Z"
        fill="#2CCF54"
      />
      <Path
        d="M9.968 9.018h-.701a.196.196 0 0 0-.195.196v4.405c0 .108.087.196.195.196h.701a.196.196 0 0 0 .195-.196V9.214a.196.196 0 0 0-.195-.196ZM14.796 9.018h-.701a.196.196 0 0 0-.195.196v2.617l-1.997-2.726a.201.201 0 0 0-.162-.087h-.701a.196.196 0 0 0-.195.196v4.405c0 .108.087.196.195.196h.701a.196.196 0 0 0 .195-.196v-2.616l2 2.73a.197.197 0 0 0 .159.082h.701a.196.196 0 0 0 .195-.196V9.214a.196.196 0 0 0-.195-.196ZM8.277 12.712H6.371V9.214a.196.196 0 0 0-.194-.197h-.702a.196.196 0 0 0-.194.197v4.404c0 .107.086.197.194.197h2.802a.196.196 0 0 0 .195-.197v-.709a.195.195 0 0 0-.195-.197ZM18.67 10.12a.195.195 0 0 0 .194-.197v-.709a.196.196 0 0 0-.194-.197h-2.802a.197.197 0 0 0-.195.197v4.404c0 .107.087.197.194.197h2.803a.196.196 0 0 0 .194-.197v-.709a.196.196 0 0 0-.194-.197h-1.906v-.744h1.906a.196.196 0 0 0 .194-.197v-.71a.196.196 0 0 0-.194-.196h-1.906v-.745h1.906Z"
        fill="#fff"
      />
    </Icon>
  );
};

export default LineColoured;
